import {
    SET_APPOINTMENT_FORMS_DATA
} from 'redux/actions/types/appointmentForms';

export const setAppointmentFormsData = (data) => {
    return {
        type: SET_APPOINTMENT_FORMS_DATA,
        data
    }
}